<style scoped lang="scss">
.nav-pills .nav-item .nav-link.active {
  background-color: #007bff;
  border-radius: 0.25rem !important;
}
.nav-pills .nav-item .nav-link {
  border: 0px solid #007bff;
}
.nav.nav-pills {
  margin-bottom: 10px;
}
</style>
<template>
  <div>
    <div v-if="loaded">
      <div class="card">
        <ul class="nav nav-pills" id="myTab" role="tablist">
          <li class="nav-item">
            <a
              class="nav-link active"
              data-toggle="tab"
              href="#payment-options"
              role="tab"
              >Zahlungsmethoden</a
            >
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              data-toggle="tab"
              href="#price-settings"
              role="tab"
              >Preiseinstellung</a
            >
          </li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div
            class="tab-pane fade show active"
            id="payment-options"
            role="tabpanel"
          >
            <div class="card">
              <div class="card-header">
                <h4>
                  Mehrwertsteuersätze
                </h4>
              </div>
              <div class="card-body">
                <div class="custom-control custom-checkbox"></div>
                <div class="form-group row">
                  <col-label>Deutschland</col-label>
                  <div class="col-8">
                    <input
                      type="number"
                      step="1"
                      min="0"
                      v-model="vatSettings.countryVatAmount_DE"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Östereich</col-label>
                  <div class="col-8">
                    <input
                      type="number"
                      step="1"
                      min="0"
                      v-model="vatSettings.countryVatAmount_AT"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label>Schweiz</col-label>
                  <div class="col-8">
                    <input
                      type="number"
                      step="0.1"
                      min="0"
                      v-model="vatSettings.countryVatAmount_CH"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4>
                  Prepaid
                  <input type="checkbox" v-model="available['prepaid']" />
                </h4>
              </div>
              <div class="card-body">
                <div class="custom-control custom-checkbox"></div>
                <div class="form-group row">
                  <col-label>An</col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_prepaid_to"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> IBAN </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_prepaid_iban"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> BIC </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_prepaid_bic"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> Prefix </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_prepaid_prefix"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4>
                  Micropayment
                </h4>
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <col-label>Sofort</col-label>
                  <input type="checkbox" v-model="available['klarna']" />
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_micropayment_sofort_url"
                      class="form-control"
                    />
                  </div>
                </div>
                <hr />
                <div class="form-group row">
                  <col-label>Call2Pay</col-label>
                  <input type="checkbox" v-model="available['call2pay']" />
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_micropayment_call2pay_url"
                      class="form-control"
                    />
                  </div>
                </div>
                <hr />
                <div class="form-group row">
                  <col-label>Handypay</col-label>
                  <input type="checkbox" v-model="available['handypay']" />
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_micropayment_handypay_url"
                      class="form-control"
                    />
                  </div>
                </div>
                <hr />
                <div class="form-group row">
                  <col-label> Paysafecard </col-label>
                  <input type="checkbox" v-model="available['paysafecard']" />
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="
                        settings.paymentMethod_micropayment_paysafecard_url
                      "
                      class="form-control"
                    />
                  </div>
                </div>
                <hr />
                <div class="form-group row">
                  <col-label>Kreditkarte</col-label>
                  <input
                    type="checkbox"
                    v-model="available['creditcard-micropayment']"
                  />
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="
                        settings.paymentMethod_micropayment_creditcard_url
                      "
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4>
                  Stripe
                  <input type="checkbox" v-model="available['creditcard']" />
                </h4>
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <col-label> key </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_stripe_key"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> secret </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_stripe_secret"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> complete </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_stripe_complete"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4>
                  Paypal
                  <input type="checkbox" v-model="available['paypal']" />
                </h4>
              </div>
              <div class="card-body">
                <div class="form-group row">
                  <col-label> client_id </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_paypal_client_id"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> secret </col-label>
                  <div class="col-8">
                    <input
                      type="text"
                      v-model="settings.paymentMethod_paypal_secret"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <col-label> Modus </col-label>
                  <div class="col-8">
                    <select
                      v-model="settings.paymentMethod_paypal_mode"
                      class="form-control"
                    >
                      <option value="live">Live</option>
                      <option value="sandbox">Sandbox</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="card-footer"></div>
            </div>
            <div class="card">
              <div class="card-header">
                <h4>
                  Gutschein
                  <input type="checkbox" v-model="available['coupon']" />
                </h4>
              </div>
              <div class="card-body"></div>
              <div class="card-footer"></div>
            </div>
          </div>
          <div class="tab-pane fade show" id="price-settings" role="tabpanel">
            <div
              class="card"
              v-for="(setting, service) in priceSettings"
              v-if="service != 'coupon'"
              :key="service"
            >
              <div class="card-header">
                <h4>
                  {{ service }}
                </h4>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col">
                    <div class="custom-control custom-radio">
                      <input
                        @click="changeType('slider', service)"
                        class="form-check-input custom-control-input"
                        v-model="setting['type']"
                        value="slider"
                        type="radio"
                        :id="service + '-slider'"
                      />
                      <label
                        class="form-check-label custom-control-label"
                        :for="service + '-slider'"
                        >Slider</label
                      >
                    </div>
                    <div class="custom-control custom-radio">
                      <input
                        @click="changeType('package', service)"
                        class="form-check-input custom-control-input"
                        v-model="setting['type']"
                        value="package"
                        type="radio"
                        :id="service + '-packet'"
                      />
                      <label
                        class="form-check-label custom-control-label"
                        :for="service + '-packet'"
                        >Packet</label
                      >
                    </div>
                  </div>
                  <div class="col">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="form-check-input custom-control-input"
                        v-model="setting['bonus']"
                        type="checkbox"
                        :id="service + '-bonus'"
                      />
                      <label
                        class="form-check-label custom-control-label"
                        :for="service + '-bonus'"
                        >Bonus</label
                      >
                    </div>
                  </div>
                </div>
                <div v-if="setting['type'] == 'package'">
                  <button
                    @click="addPackage(setting)"
                    class="btn btn-small btn-default"
                  >
                    +Packet
                  </button>
                  <div class="row">
                    <div class="col-1">
                      <label>
                        Menge
                      </label>
                    </div>
                    <div class="col-1">
                      <label>
                        Preis
                      </label>
                    </div>
                  </div>
                  <div
                    v-for="(pricePackage, key) in setting['packages']"
                    :key="key"
                    class="row"
                  >
                    <div class="col-1">
                      <input
                        min="0"
                        type="number"
                        :id="service + '-' + key + '-amount'"
                        class="form-control"
                        v-model="pricePackage['amount']"
                      />
                    </div>
                    <div class="col-1">
                      <input
                        min="0"
                        step="0.01"
                        type="number"
                        :id="service + '-' + key + '-price'"
                        class="form-control"
                        v-model="pricePackage['price']"
                      />
                    </div>
                    <button
                      @click="removePackage(setting.packages, key)"
                      class="close"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary" type="submit" @click="save()">
      Speichern
    </button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loaded: false,
      available: {
        paypal: false,
        creditcard: false,
        "creditcard-micropayment": false,
        klarna: false,
        prepaid: false,
        coupon: false,
        call2pay: false,
        paysafecard: false,
        handypay: false
      },
      settings: {},
      vatSettings: {},
      priceSettings: {}
    };
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      let available = this.$store.getters["setting/key"](
        "availablePaymentMethods"
      ).split(",");
      Object.keys(this.available).forEach(
        key => (this.available[key] = available.includes(key))
      );
      let all = this.$store.getters["setting/all"];
      this.priceSettings = JSON.parse(all["priceSettings"]);
      Object.keys(all)
        .filter(key => key.includes("paymentMethod_"))
        .forEach(key => (this.settings[key] = all[key]));
      Object.keys(all)
        .filter(key => key.includes("countryVatAmount_"))
        .forEach(key => (this.vatSettings[key] = all[key]));
      this.loaded = true;
    });
  },
  methods: {
    changeType(type, service) {
      if (type == "package") {
        this.$set(this.priceSettings[service], "packages", []);
      } else if (this.priceSettings[service].packages) {
        this.priceSettings[service].packages = undefined;
      }
    },
    addPackage(setting) {
      setting.packages.push({ amount: 0, price: 0 });
    },
    removePackage(packages, key) {
      packages.splice(
        packages.findIndex(index => index == key),
        1
      );
    },
    save() {
      let available = Object.keys(this.available)
        .filter(key => this.available[key])
        .join(",");
      this.$store
        .dispatch("setting/update", {
          availablePaymentMethods: available,
          ...this.settings,
          ...this.vatSettings,
          priceSettings: JSON.stringify(this.priceSettings)
        })
        .then(() =>
          this.$notify({
            title: "Einstellungen gespeichert",
            type: "success"
          })
        );
    }
  }
};
</script>

<style></style>
